<template>
    <v-app id="inspire" class="app dashboard">
        <app-drawer class="app--drawer" :show-drawer="showDrawer" @close-drawer="drawerVisiableFalse"></app-drawer>
        <app-toolbar class="app--toolbar" @side-icon-click="handleDrawerVisiable"></app-toolbar>
        <v-content>
            <!-- Page Header -->
            <page-header v-if="actualRoute !== 'Dashboard'"></page-header>

            <div class="page-wrapper">
                <router-view></router-view>
            </div>
            <!-- App Footer -->
            <v-card>
                <v-footer height="auto" class="primary darken-1 white--text pa-3 app--footer">
                    <span class="caption">Version 2.0.0</span>
                    <v-spacer></v-spacer>
                    <span class="caption">Todocolegios &copy; {{ new Date().getFullYear() }}</span>
                </v-footer>
            </v-card>
        </v-content>
        <!-- Go to top -->
        <app-fab></app-fab>
    </v-app>
</template>

<script>
import AppDrawer from "@/components/AppDrawer"
import AppToolbar from "@/components/AppToolbar"
import AppFab from "@/components/AppFab"
import PageHeader from "@/components/PageHeader"

export default {
    components: {
        AppDrawer,
        AppToolbar,
        AppFab,
        PageHeader
    },

    data() {
        return {
            showDrawer: false
        }
    },
    methods: {
        handleDrawerVisiable() {
            this.showDrawer = !this.showDrawer
        },

        drawerVisiableFalse() {
            this.showDrawer = false
        }
    },
    computed: {
        actualRoute() {
            return this.$route.name
        }
    },
    created() {}
}
</script>

<style scoped>
.page-wrapper {
    min-height: calc(100vh - 64px - 50px - 81px);
}
</style>
